import { StoryblokComponent, storyblokEditable } from "@storyblok/react";

const Grid = ({ blok }) => {
  console.log("blok keys:", Object.keys(blok));
console.log("backgroundcolor value:", blok.backgroundcolor);
  return (
    <div 
      style={{
        display: "flex",
        justifyContent: "space-around",
        backgroundColor: blok.backgroundcolor || "transparent",
      }}
      {...storyblokEditable(blok)}
       className={`grid ${blok.gridclass || ""} grid--cols-${blok.columns?.length}`}
    >
      {blok.columns?.map((column) => (
        <StoryblokComponent blok={column} key={column._uid} />
      ))}
    </div>
  );
};

export default Grid;